import React, { useCallback } from "react";
import Toolbar from "src/components/Toolbar";
import data from "./data";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NUM_OF_COLS = 2;
const InsuranceService = (props) => {
  const history = useHistory();
  const { t } = useTranslation();

  const _handleClick = useCallback(
    (item) => {
      console.log("Clicking", item);
      if (item.id === 2) {
        history.push("/buy-insurance/cancer/product-info");
      }
    },
    [history]
  );

  const _renderItem = (item, index) => {
    return (
      <div
        className="bg-surface rounded-lg pt-8 pb-4 px-8 flex flex-col justify-center items-center"
        onClick={() => _handleClick(item)}
        key={item.id}
      >
        <div className="pb-4">
          <img src={item.icon} className="w-10 h-10" />
        </div>
        <div className="text-center text-sm font-semibold text-onSurfaceVariant">
          {item.name}
        </div>
      </div>
    );
  };

  return (
    <div className="screen-container bg-background">
      <Toolbar title={t("insurance_service")} />
      <div className="max-w-md mx-auto p-6">
        <div
          className={`grid grid-flow-row grid-cols-${NUM_OF_COLS} grid-rows-${Math.ceil(
            data.length / NUM_OF_COLS
          )} gap-4`}
        >
          {data.map(_renderItem)}
        </div>
      </div>
    </div>
  );
};

export default InsuranceService;
